var plugin_rtlignore_default = {
  "alignLeft": "iNgsZ",
  "textWrapNowrap": "_3bHl-",
  "alignRight": "_0-oQZ",
  "alignCenter": "_7uHiT",
  "sizeFullWidth": "ZohH0",
  "renderedInTable": "_3vexQ",
  "sizeOriginal": "t2c6U",
  "sizeContent": "oNmNL",
  "sizeSmall": "fz0mI",
  "sizeSmallCenter": "_2L9Ly",
  "flex": "m-rvj",
  "atomic": "tsI7l",
  "embed": "QSlLN",
  "horizontalScrollbar": "_3nyRc",
  "pluginContainerMobile": "i40bV"
};
export {
  plugin_rtlignore_default as default
};
//# sourceMappingURL=plugin.rtlignore-scss.js.map
